module.exports = __webpack_public_path__ + "img/beigedown.1a7b29df.png";